export enum StatusCabecalhoConferenciaDeFatura {
  Pendente,
  Fechado,
}
